export default () => ({
    justifySelf: 'end',
});
